// 业务方
const CLIENT_TYPE = {
  BASE: 0, // 基础词库
  YUNPIAN: 1,
  YCLOUD: 2
}

// 拦截原因
const GROUP_FUNCTION = {
  OPERATOR_INTERCEPTION: 0,
  BLACK_WORD: 101,
  URL_DETECTION: 111,
  SPECIAL_WORDS: 121,
  ABNORMAL_CHAR: 131,
  VIOLATION_DATA: 100,
  INTERCEPT_DATA: 110
}

// 词库用途
const GROUP_PURPOSE = {
  BLACK_WORD: 101,
  URL_DETECTION: 111
}

// 词库类型
const GROUP_TYPE = {
  SYSTEM_TEXT: 0, // 系统文本
  SYSTEM_ADDRESS: 1, // 系统网址
  SYSTEM_CONTACT: 2, // 系统联系方式
  MANUAL_WORD: -1 // 人工添加词库
}

// 系统基础词库分为系统文本、系统网址、系统联系方式
const GROUP_TYPE_MAP = {
  [GROUP_TYPE.SYSTEM_TEXT]: '系统基础词库',
  [GROUP_TYPE.SYSTEM_ADDRESS]: '系统基础词库',
  [GROUP_TYPE.SYSTEM_CONTACT]: '系统基础词库',
  [GROUP_TYPE.MANUAL_WORD]: '人工添加词库'
}

// 词库状态
const GROUP_STATUS = {
  STOP: 0,
  OPEN: 1
}

// 黑词分级
const WORD_LEVEL = {
  LEVEL_1: 1,
  LEVEL_2: 2,
  LEVEL_3: 3
}

// 过滤黑词等级
const BLACK_LEVEL = {
  NO: 0,
  ONE: 1,
  ONE_TWO: 2,
  ALL: 3
}

// 文本特征
const BLACK_WORD_FEATURE = {
  OTHER: 0,
  WEIXIN: 101,
  QQ: 102,
  WEB: 103
}

// 场景编码
const CLIENT_GROUP = {
  TEST: 100,
  UP: 101,
  HANDLE: 102,
  SUBMIT: 105,
  CONTENT_INPUT: 106,
  SMS_SIGN: 103,
  SMS_TEMPLATE: 104,
  VIDEO_VARIABLE: 201,
  CRM_TEST: 301,
  OTHER: 0,
  SHORT_LINK: 400
}

// 监控频率
const MONITOR_FREQUENCY = {
  DAILY: 0,
  WEEKLY: 1
}

// 监控理由
const MONITOR_REASON = {
  OTHER: 0, // 其他
  OVERSEAS_QUALIFICATIONS: 1, // 海外资质
  PSEUDO_FINANCIAL: 2, // 疑似伪金融/博彩
  NORMAL_TEMPLATE: 4, // 正常模版发违规
  RISK_TEMPLATE: 5, // 高危权限发违规
  MULTI_VARIABLE: 6, // 多变量模版
  PERSONAL_VARIABLE: 7, // 个人变量模版
  ALL: -1 // 全部
}

// 资质认证
const QUALIFICATION_APPROVE = {
  COMPANY: 0,
  PERSONAL: 1
}

// 监控状态
const MONITOR_STATUS = {
  NOT_START: 0,
  MONITORING: 1,
  STOPPED: 2
}

// 审核结果
const AUDIT_RESULT = {
  NOT_AUDIT: 0,
  NORMAL: 1,
  VIOLATION: -1
}

// 审核状态
const AUDIT_STATUS = {
  SHIELD_REJECT: 0,
  OPERATORS_REJECT: 1,
  ARTIFICIAL_PASS: 2,
  ARTIFICIAL_REJECT: 3,
  SUSPECTED_VIOLATION: 4
}

// 策略状态
const STRATEGY_STATUS = {
  STOP: 0,
  OPEN: 1
}

// 网址/域名/IP检测
// 有效期
const AVAILABLE_TERM = {
  HALF_YEAR: 180,
  ONE_YEAR: 360,
  TWO_YEARS: 720,
  FOREVER: -1
}

// 文本类型
const TEXT_TYPE = {
  URL: 1,
  DOMAIN: 2,
  IP: 3
}

// 文本用途
const TEXT_FUNCTION = {
  BLACK_LIST: false,
  WHITE_LIST: true
}

// 审计日志列表 --> 操作类型
const OPERATION_TYPE = {
  OTHER: 9999,
  ADD: 1,
  DELETE: 2,
  UPDATE: 3,
  QUERY: 4,
  LOGIN: 5
}

// 客户监控告警 --> 告警标题
const ALERT_TITLE = {
  FREQUENT_HIT_RISK: 0
}

// 短信审核状态 --> 数据统计/内容审核
const SMS_STATE = {
  UNDER_REVIEW: 0,
  NORMAL: 1,
  BANNED: 2
}

const SMS_STATE_MAP = {
  [SMS_STATE.UNDER_REVIEW]: '待审核',
  [SMS_STATE.NORMAL]: '内容正常',
  [SMS_STATE.BANNED]: '内容违规'
}

const SMS_SOURCE_MAP = {
  [SMS_STATE.NORMAL]: '夜间发送量监控',
  [SMS_STATE.BANNED]: '发送量突增'
}

export default {
  CLIENT_TYPE,
  clientTypeMap: {
    [CLIENT_TYPE.YUNPIAN]: '云片',
    [CLIENT_TYPE.YCLOUD]: 'yCloud'
  },
  GROUP_FUNCTION,
  groupFunctionMap: {
    [GROUP_FUNCTION.BLACK_WORD]: '黑词过滤',
    [GROUP_FUNCTION.OPERATOR_INTERCEPTION]: '运营商拦截',
    [GROUP_FUNCTION.URL_DETECTION]: '网址检测',
    [GROUP_FUNCTION.SPECIAL_WORDS]: '特殊字符检测',
    [GROUP_FUNCTION.ABNORMAL_CHAR]: '变体字检测'
  },
  GROUP_PURPOSE,
  groupPurposeMap: {
    [GROUP_PURPOSE.BLACK_WORD]: '黑词过滤',
    [GROUP_FUNCTION.URL_DETECTION]: '网址检测',
    [GROUP_FUNCTION.ABNORMAL_CHAR]: '变体字检测'
  },
  GROUP_TYPE,
  GROUP_TYPE_MAP,
  GROUP_STATUS,
  groupStatusMap: {
    [GROUP_STATUS.STOP]: '已停用',
    [GROUP_STATUS.OPEN]: '已启动 '
  },
  WORD_LEVEL,
  wordLevelMap: {
    [WORD_LEVEL.LEVEL_1]: '一级',
    [WORD_LEVEL.LEVEL_2]: '二级',
    [WORD_LEVEL.LEVEL_3]: '三级 '
  },
  BLACK_LEVEL,
  blackLevelMap: {
    [BLACK_LEVEL.NO]: '不过滤黑词',
    [BLACK_LEVEL.ONE]: '只过滤一级黑词',
    [BLACK_LEVEL.ONE_TWO]: '过滤一级和二级黑词',
    [BLACK_LEVEL.ALL]: '过滤全部等级的黑词'
  },
  BLACK_WORD_FEATURE,
  blackWordFeatureMap: {
    [BLACK_WORD_FEATURE.WEIXIN]: '包含微信',
    [BLACK_WORD_FEATURE.QQ]: '包含QQ',
    [BLACK_WORD_FEATURE.WEB]: '包含网址',
    [BLACK_WORD_FEATURE.OTHER]: '其他'
  },
  CLIENT_GROUP,
  clientGroupMap: {
    [CLIENT_GROUP.TEST]: '测试屏蔽词检查',
    [CLIENT_GROUP.UP]: '先提后审检测',
    [CLIENT_GROUP.HANDLE]: '手工短信审核',
    [CLIENT_GROUP.SUBMIT]: '手工短信提交',
    [CLIENT_GROUP.CONTENT_INPUT]: '手工短信内容输入',
    [CLIENT_GROUP.SMS_SIGN]: '短信签名提交',
    [CLIENT_GROUP.SMS_TEMPLATE]: '短信模版提交',
    [CLIENT_GROUP.VIDEO_VARIABLE]: '视频短信变量检测',
    [CLIENT_GROUP.CRM_TEST]: '营销云-测试屏蔽词',
    [CLIENT_GROUP.SHORT_LINK]: '短链服务',
    [CLIENT_GROUP.OTHER]: '其他'
  },
  MONITOR_FREQUENCY,
  monitorFrequencyMap: {
    [MONITOR_FREQUENCY.DAILY]: '每天',
    [MONITOR_FREQUENCY.WEEKLY]: '每周'
  },
  MONITOR_REASON,
  QUALIFICATION_APPROVE,
  qualificationApproveMap: {
    [QUALIFICATION_APPROVE.COMPANY]: '企业',
    [QUALIFICATION_APPROVE.PERSONAL]: '个人',
  },
  MONITOR_STATUS,
  monitorStatusMap: {
    [MONITOR_STATUS.NOT_START]: '未开始',
    [MONITOR_STATUS.MONITORING]: '监控中',
    [MONITOR_STATUS.STOPPED]: '已停止'
  },
  AUDIT_RESULT,
  auditResultMap: {
    [AUDIT_RESULT.NOT_AUDIT]: '未审核',
    [AUDIT_RESULT.NORMAL]: '正常',
    [AUDIT_RESULT.VIOLATION]: '违规'
  },
  AUDIT_STATUS,
  auditStatusMap: {
    [AUDIT_STATUS.SHIELD_REJECT]: '风控审核不通过',
    [AUDIT_STATUS.OPERATORS_REJECT]: '运营商审核不通过',
    [AUDIT_STATUS.ARTIFICIAL_PASS]: '人工审核通过',
    [AUDIT_STATUS.ARTIFICIAL_REJECT]: '人工审核不通过',
    [AUDIT_STATUS.SUSPECTED_VIOLATION]: '风控审核疑似违规'
  },
  STRATEGY_STATUS,
  serategyStatusMap: {
    [STRATEGY_STATUS.STOP]: '未开启',
    [STRATEGY_STATUS.OPEN]: '已开启',
  },
  AVAILABLE_TERM,
  availableTermMap: {
    [AVAILABLE_TERM.HALF_YEAR]: '6个月',
    [AVAILABLE_TERM.ONE_YEAR]: '12个月',
    [AVAILABLE_TERM.TWO_YEARS]: '24个月',
    [AVAILABLE_TERM.FOREVER]: '永久生效'
  },
  TEXT_TYPE,
  textTypeMap: {
    [TEXT_TYPE.URL]: '网址',
    [TEXT_TYPE.DOMAIN]: '域名',
    [TEXT_TYPE.IP]: 'IP'
  },
  TEXT_FUNCTION,
  textFunctionMap: {
    [TEXT_FUNCTION.BLACK_LIST]: '黑名单',
    [TEXT_FUNCTION.WHITE_LIST]: '白名单'
  },
  OPERATION_TYPE,
  operationTypeMap: {
    [OPERATION_TYPE.LOGIN]: '登录',
    [OPERATION_TYPE.ADD]: '新增',
    [OPERATION_TYPE.DELETE]: '删除',
    [OPERATION_TYPE.UPDATE]: '修改',
    [OPERATION_TYPE.QUERY]: '查询',
    [OPERATION_TYPE.OTHER]: '其他'
  },
  ALERT_TITLE,
  alertTitleMap: {
    [ALERT_TITLE.FREQUENT_HIT_RISK]: '客户频繁命中风控检测'
  },
  SMS_STATE,
  SMS_STATE_MAP,
  SMS_SOURCE_MAP
}
